import { render, staticRenderFns } from "./RecommendProduct.vue?vue&type=template&id=c2a129d0&scoped=true&"
import script from "./RecommendProduct.vue?vue&type=script&lang=js&"
export * from "./RecommendProduct.vue?vue&type=script&lang=js&"
import style0 from "./RecommendProduct.vue?vue&type=style&index=0&id=c2a129d0&prod&lang=scss&scoped=true&"
import style1 from "./RecommendProduct.vue?vue&type=style&index=1&id=c2a129d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a129d0",
  null
  
)

export default component.exports